import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Sisesta siia otsisõna nt diivan, magamistuba, põrandalamp jms...

  <span style="color:#85c1dc;">**FI:**</span>
  Kirjoita tähän hakusana, esim. sohva, makuuhuone, lattiavalaisin jne...

  <span style="color:#85c1dc;">**RU:**</span>
  Введите слово для поиска здесь, например, диван, спальня, торшер и т. д.
*/
/* @__NO_SIDE_EFFECTS__ */
const m535 = msg(
  mf`Sisesta siia otsisõna nt diivan, magamistuba, põrandalamp jms...`,
  mf`Kirjoita tähän hakusana, esim. sohva, makuuhuone, lattiavalaisin jne...`,
  mf`Введите слово для поиска здесь, например, диван, спальня, торшер и т. д.`,
)

export { m535 as 'w.module.categories_search.placeholder' }